'use es6';

export const overrideTextTo = {
  noNO: 'no-no',
  no: 'no-no'
};